import {Feature} from '../../core/model/feature.js';

const name = 'regard';
export default name;
export const regardFeature = new Feature(name);

regardFeature.defineRemoveWhenHidden('onsw-regard-button');
